import { generateTypes } from '../../utils/HttpReducerHelper';

export const signup = generateTypes('SIGNUP', 'SIGNUP');
